<template>
	<component :is="component" v-if="component" 
		:data="data" 
		:ready="ready" 
		:columnClasses="classes" 
		v-on:changeBackgroundShade="changeBackgroundShade" />
</template>

<script>
export default {
	name: 'base-dynamic-block',
	props: ['data', 'columnClasses', 'folder', 'ready'],
	data() {
		return {
			component: null,
			backgroundShade: null
		}
	},
	computed: {
		classes() {
			return (this.type==='Text-wysiwyg') ? 'columns small-12 medium-8 medium-offset-2 large-4 large-offset-4 xlarge-4 x-large-offset-4' : this.columnClasses
		},
		loader() {
			if (!this.type) {
				return null
			}
			if (this.folder) {
				return () => import(`./${this.folder}/${this.type}`)
			}
			if(this.data.type==='line'||this.data.type==='pie'||this.data.type==='bar') {
				return () => import(`./graph/${this.type}`)
			}
			if(this.type==='Text-wysiwyg') {
				return () => import(`./overlay/content/TextWysiwyg`)
			}
			if(this.type==='Table') {
				return () => import(`./table/Table`)
			}
			return () => import(`./overlay/content/${this.type}`)
		},
		type() {
			var string = (this.data.acf_fc_layout!=='graph') ? this.data.acf_fc_layout : this.data.type
			return this.$options.filters.componentName(string)
		}
	},
	methods: {
		changeBackgroundShade(shade) {
			this.$emit('changeBackgroundShade', shade);
		},
		handleScroll () {

			var direction = (this.scrollOffset > window.pageYOffset) ? 'up' : 'down';
			this.scrollOffset = window.pageYOffset;

			var topSwitchOffset = window.innerHeight - this.headerLinkOffset;

			var offsetTopPosition = this.$el.offsetTop - window.pageYOffset;
			var offsetTop = offsetTopPosition*-1;
			if (direction==='down') {
				if (offsetTop >= (topSwitchOffset - 50) && offsetTop <= (topSwitchOffset + 50)) {
					this.active = true;
					this.changeBackgroundShade();
				}
			} else {
				offsetTopPosition -= window.pageYOffset;
				offsetTop = offsetTopPosition*-1 + this.$el.clientHeight;
				if (offsetTop >= (topSwitchOffset - 50) && offsetTop <= (topSwitchOffset + 50)) {
					this.changeBackgroundShade();
				}
			}
		}
	},
	mounted() {
		this.loader()
			.then(() => {
				this.component = () => this.loader()
			})
			.catch(() => {
				this.component = false
			})
	}
}
</script>